export const actionsStyles = {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
};

export const reasonContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const reasonActionsStyles = {
  display: 'flex',
  gap: '8px',
};

export const slaGroupContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const slaGroupPromptStyles = {
  color: ({ palette }) => palette.text.secondary,
};
